import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notify, Typography, Stack } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getWorkloadQueryKey } from 'hooks/queries/workload-optimization/useWorkloadQuery';
import { getWorkloadScalingPoliciesQueryKey } from 'hooks/queries/workload-optimization/useWorkloadScalingPoliciesQuery';
import { getWorkloadsQueryKey } from 'hooks/queries/workload-optimization/useWorkloadsQuery';

export const useUpdateWorkloadScalingPolicyMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiClient.workloadOptimization.updateWorkloadScalingPolicy,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getWorkloadScalingPoliciesQueryKey(),
      });
      queryClient.invalidateQueries({ queryKey: getWorkloadQueryKey() });
      queryClient.invalidateQueries({
        queryKey: getWorkloadsQueryKey(),
      });

      notify.success(
        <Stack gap={4} direction="row">
          <Typography variant="P14B" color="green.200">
            Changes saved successfully!
          </Typography>
        </Stack>
      );
    },
  });
};
